import axios from '../axios'

// クイズ作成（設問・選択肢ネスト）
const postQuizApi = async (courseId, payload) => {
  return await axios.post(`api/lms/courses/${courseId}/quizzes`, payload)
}

export default postQuizApi
